import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GenericLabelValue } from "src/app/shared/models/DTO/GenericLabelValue.dto";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { InputType } from "src/app/shared/models/enums/InputType.enum";
import { OOOrderType, OrderTypeOrderIdentifier } from "src/app/shared/models/oo-order-type";

@Component({
	selector: "app-order-type-kiosk-setup",
	templateUrl: "./order-type-kiosk-setup.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class OrderTypeKioskSetupComponent implements OnInit {
	@Input() orderType: OOOrderType;
	@Output() orderTypeChange = new EventEmitter<OOOrderType>();

	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	identificationType: GenericLabelValue[] = [];
	identifierSelected: OrderTypeOrderIdentifier;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {
		for (const [k, v] of Object.entries(InputType)) {
			if (!isNaN(+v)) {
				this.identificationType.push({
					label: this.app.references.toTitleCase(k),
					value: +v,
				});
			}
		}

		if (!this.orderType.identifierNameOptions) {
			this.orderType.identifierNameOptions = [];
		} else {
		}
	}

	onAdd() {
		this.identifierSelected = new OrderTypeOrderIdentifier({
			created: this.app.moment().format(),
			unsaved: true,
		});
	}

	onSave(identifier: OrderTypeOrderIdentifier) {
		if (identifier.unsaved && this.orderType.identifierNameOptions.some((i) => i === identifier.name)) {
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `Cannot save a duplicate order identifier.` });
		} else {
			delete identifier.unsaved;
			this.orderType.identifierNameOptions.push(identifier.name);
		}
		this.changesToSaveChange.emit(true);
	}

	onDelete(identifier: OrderTypeOrderIdentifier) {
		this.orderType.identifierNameOptions.splice(this.orderType.identifierNameOptions.findIndex((i) => i === identifier.name));
		this.changesToSaveChange.emit(true);
	}
}
